// src/auth/hooks/useSession.ts
import { useEffect, useState } from "react";
import { sessionManager, SessionData } from "./sessionManager";

export const useSession = () => {
  const [session, setSession] = useState<SessionData | null>(() => {
    // Lire d'abord localStorage (rememberMe) puis sessionStorage
    const jwtToken =
      localStorage.getItem("jwtToken") || sessionStorage.getItem("jwtToken");
    const refreshToken =
      localStorage.getItem("refreshToken") || sessionStorage.getItem("refreshToken");

    if (jwtToken && refreshToken) {
      return { jwtToken, refreshToken };
    }
    return null;
  });

  useEffect(() => {
    // S'abonner aux mises à jour cross-onglets
    const unsubscribe = sessionManager.subscribe((newSession) => {
      setSession(newSession);
    });

    // Forcer lecture initiale pour le nouvel onglet
    if (!session) {
      const jwtToken =
        localStorage.getItem("jwtToken") || sessionStorage.getItem("jwtToken");
      const refreshToken =
        localStorage.getItem("refreshToken") || sessionStorage.getItem("refreshToken");
      if (jwtToken && refreshToken) {
        setSession({ jwtToken, refreshToken });
      }
    }

    return unsubscribe;
  }, []);

  return { session };
};
